import { render, staticRenderFns } from "./JDictSelectTag.vue?vue&type=template&id=888152d0&scoped=true"
import script from "./JDictSelectTag.vue?vue&type=script&lang=js"
export * from "./JDictSelectTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888152d0",
  null
  
)

export default component.exports